import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { ticketRequestError } from '../ticket-form.utils';
import { Empty_Ticket_Interface, Ticket_Interface } from 'src/app/Interface/Ticket_Interface';
import { Ticket_Ref_Interface } from 'src/app/Interface/Ticket_Ref_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { TicketService } from 'src/app/Service/Ticket/Ticket.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-TicketList',
  templateUrl: './TicketList.component.html',
  styleUrls: ['./TicketList.component.scss', '../ticket-shared.css']
})
export class TicketListComponent implements OnInit, OnDestroy {
  ErrorMessage = '';
  private listRequest?: Subscription;
  private detailRequest?: Subscription;
  typeUser: any
  Switcher_view: number = -1
  Show_Draft_Ticket: number = 1
  page = 0

  constructor(
    private Alertify_Service: AlertifyService,
    private Ticket_Service: TicketService,
    private Nav_Service: NavService,
  ) { }

  ngOnInit() {
    this.typeUser = localStorage.getItem('Daro_User_Type');
    var MenuId = 1102
    if (this.typeUser == '1' || this.typeUser == '2')
      MenuId = 1104

    this.Nav_Service.CheckValidPage(MenuId).subscribe(
      data => {
        this.ReadData_Ticket()
      }
      , error => {
        this.ErrorMessage = ticketRequestError(error);
        this.Alertify_Service.ErrorMessage(this.ErrorMessage);
      }
    )
  }

  Proccessing: boolean = false
  Ticket_Datalist: Array<Ticket_Interface> = []
  ReadData_Ticket() {
    this.listRequest?.unsubscribe();
    this.detailRequest?.unsubscribe();
    this.canReply = false;
    this.ErrorMessage = '';
    this.Seleted_Ticket_Item = Empty_Ticket_Interface()
    this.Proccessing = true
    this.Ticket_Datalist = []
    this.listRequest = this.Ticket_Service.GetRecord(this.Show_Draft_Ticket).pipe(finalize(() => this.Proccessing = false)).subscribe(
      data => {
        this.Proccessing = false
        this.Ticket_Datalist = data
      }, error => { this.ErrorMessage = ticketRequestError(error); this.Alertify_Service.ErrorMessage(this.ErrorMessage); }
    )
  }

  BaseUrl = environment.BaseUrl
  Proccessing_Ref: boolean = false
  canReply: boolean = false
  Ticket_Datalist_Ref: Array<Ticket_Ref_Interface> = []

  Seleted_Ticket_Item: Ticket_Interface = Empty_Ticket_Interface()

  ReadData_Ref_Ticket(item: Ticket_Interface) {
    this.detailRequest?.unsubscribe();
    this.ErrorMessage = '';
    this.canReply = false
    this.Rest_List_Selection()
    item.selected = true
    this.Seleted_Ticket_Item = item
    this.Proccessing_Ref = true
    this.Ticket_Datalist_Ref = []
    this.detailRequest = this.Ticket_Service.GetDetail(item.id).pipe(finalize(() => this.Proccessing_Ref = false)).subscribe(
      data => {
        this.Proccessing_Ref = false
        this.Ticket_Datalist_Ref = data['result']
        this.canReply = data['canReply'] === true
      }, error => { this.canReply = false; this.ErrorMessage = ticketRequestError(error); this.Alertify_Service.ErrorMessage(this.ErrorMessage); }
    )
  }


  Rest_List_Selection() {
    for (let item of this.Ticket_Datalist) {
      item.selected = false
    }
  }

  Show_View_ReplyForm() {
    if (!this.canReply || this.Proccessing_Ref) return;
    this.Switcher_view = 0
  }

  OnGet_Back_Ticket(id: number) {

    this.Switcher_view = id
    this.ReadData_Ref_Ticket(this.Seleted_Ticket_Item)

  }

  ngOnDestroy(): void {
    this.listRequest?.unsubscribe();
    this.detailRequest?.unsubscribe();
  }


  getTicketFileName(file: string): string {
    if (!file) return '';
    const normalized = file.split('?')[0];
    const parts = normalized.split('/');
    return parts[parts.length - 1] || '';
  }

  getTicketFileExtension(file: string): string {
    const fileName = this.getTicketFileName(file);
    if (!fileName || fileName.indexOf('.') < 0) {
      return 'بدون پسوند';
    }

    return fileName.split('.').pop()?.toUpperCase() || 'FILE';
  }

  trackByFile(index: number, file: string): string {
    return file;
  }

}
